import { render } from "./FlowList.vue?vue&type=template&id=73fb480c&scoped=true&ts=true"
import script from "./FlowList.vue?vue&type=script&lang=ts"
export * from "./FlowList.vue?vue&type=script&lang=ts"

import "./FlowList.vue?vue&type=style&index=0&id=73fb480c&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fb480c"]])

export default __exports__